import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { KnowledgeAPIModel, PaginatedAPI, UserAPIModel } from 'src/app/models/api.model'
import { CommonService } from 'src/app/services/common/common.service'
import { load_knowledge_quick_option_details } from 'src/app/store/action/knowledge.action'
import { getUserFromState } from 'src/app/store/selector/initialize.selector'
import { quickSelectList } from 'src/app/store/selector/knowledge.selector'
import { AppState } from 'src/app/store/state/app.state'

@Component({
  selector: 'app-knowledge-quick-select',
  templateUrl: './knowledge-quick-select.component.html',
  styleUrls: ['./knowledge-quick-select.component.scss']
})
export class KnowledgeQuickSelectComponent implements OnInit {
  constructor(private route: Router, private appState: Store<AppState>, private cs: CommonService) {}
  user$: Subscription
  user: UserAPIModel
  readonly userType = GlobalConstants.USER_TYPE
  knowledgeQuickSelectList$: Observable<PaginatedAPI<KnowledgeAPIModel>>
  queryParamValues = {
    pageNo: 0,
    pageLimit: 10
  }

  searchRequestBody = {
    heading: '',
    displayForEmployee: true,
    displayForAdmin: true,
    category: '',
    enableInQuickLinks: true
  }

  ngOnInit(): void {
    this.getUserDetails()
    this.loadSummaryData()
  }

  getUserDetails = () => {
    this.user$ = this.appState.select(getUserFromState).subscribe((user: UserAPIModel) => {
      if (user) {
        this.user = user
      }
    })
  }

  private loadSummaryData() {
    let options = {
      queryParams: this.buildQueryParams(),
      searchRequestBody: this.searchRequestBody
    }
    this.knowledgeQuickSelectList$ = this.appState.select(quickSelectList())
    this.appState.dispatch(load_knowledge_quick_option_details(options))
  }

  buildQueryParams = (): { key: string; value: string }[] => {
    return [
      {
        key: 'pageNo',
        value: this.queryParamValues.pageNo.toString()
      },
      {
        key: 'limit',
        value: this.queryParamValues.pageLimit.toString()
      }
    ]
  }

  addNewArticle() {
    this.cs.routeTo(`/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/1`)
  }

  viewArticle(id: any) {
    const viewPageLink = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${id}/${GlobalConstants.ROUTING.VIEW}`
    this.cs.route(viewPageLink)
  }

  viewAllArticle() {
    const viewAllPageLink = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.LIST}`
    this.cs.route(viewAllPageLink)
  }

  back() {
    const searchPageLink = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}`
    this.cs.route(searchPageLink)
  }

  ngOnDestroy() {
    this.user$?.unsubscribe()
  }
}
